import angular from 'angular';

class UploadServ {
  constructor($http) {
    this.http = $http
  }
  upload(endpoint, files, listener) {
    let data = new FormData()
    data.append('format', 'file')
    for (var i = 0; i < files.length; i++) {
      data.append('file', files[i])
    }
    return this.http.post(endpoint, data, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined },
      uploadEventHandlers: {
        progress: listener
      }
    })
  }
}

UploadServ.$inject = ['$http']

export default angular.module('services.upload', [])
  .service('UploadServ', UploadServ)
  .name;



// WEBPACK FOOTER //
// ./project/services/upload.js